/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Workspace } from './workspace';


export interface ProjectMetadata { 
    /**
     * The Project\'s Creation Date
     */
    created_at: string;
    /**
     * The environment of the project. prod Production stage Staging dev Development
     */
    environment: ProjectMetadata.EnvironmentEnum;
    /**
     * The project\'s data home region eu-central EUCentral asia-northeast AsiaNorthEast us-east USEast us-west USWest us US global Global
     */
    home_region: ProjectMetadata.HomeRegionEnum;
    hosts: Array<string>;
    /**
     * The project\'s ID.
     */
    readonly id: string;
    /**
     * The project\'s name if set
     */
    name: string;
    /**
     * The project\'s slug
     */
    readonly slug: string;
    /**
     * The state of the project. running Running halted Halted deleted Deleted
     */
    state: ProjectMetadata.StateEnum;
    subscription_id?: string | null;
    subscription_plan?: string | null;
    /**
     * Last Time Project was Updated
     */
    updated_at: string;
    workspace?: Workspace;
    workspace_id?: string | null;
}
export namespace ProjectMetadata {
    export type EnvironmentEnum = 'prod' | 'stage' | 'dev';
    export const EnvironmentEnum = {
        Prod: 'prod' as EnvironmentEnum,
        Stage: 'stage' as EnvironmentEnum,
        Dev: 'dev' as EnvironmentEnum
    };
    export type HomeRegionEnum = 'eu-central' | 'asia-northeast' | 'us-east' | 'us-west' | 'us' | 'global';
    export const HomeRegionEnum = {
        EuCentral: 'eu-central' as HomeRegionEnum,
        AsiaNortheast: 'asia-northeast' as HomeRegionEnum,
        UsEast: 'us-east' as HomeRegionEnum,
        UsWest: 'us-west' as HomeRegionEnum,
        Us: 'us' as HomeRegionEnum,
        Global: 'global' as HomeRegionEnum
    };
    export type StateEnum = 'running' | 'halted' | 'deleted';
    export const StateEnum = {
        Running: 'running' as StateEnum,
        Halted: 'halted' as StateEnum,
        Deleted: 'deleted' as StateEnum
    };
}


